export class NetworkRequestError extends Error {
    constructor() {
        super('NETWORK_REQUEST_ERROR');
    }
}
//# sourceMappingURL=NetworkRequestError.js.map